import AkoBonusIcon from 'assets/images/AkoBonusIcon.svg?react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import './styles.scss';

interface AkoBonusInfoProps {
	bonusAmount: number;
	currentBonusValue?: number;
	type?: 'history' | 'betslip';
}

const AkoBonusInfo = ({ bonusAmount, currentBonusValue, type = 'betslip' }: AkoBonusInfoProps) => {
	const [t] = useTranslation();

	return (
		<div className={cn('AkoBonusInfo', { 'AkoBonusInfo--betslip': type === 'betslip' }, { 'AkoBonusInfo--history': type === 'history' })}>
			<div className="AkoBonusInfo__leftSide">
				<AkoBonusIcon />
				{currentBonusValue ? <p>{t('akoBoosterValue', { currentBonusValue: currentBonusValue })}</p> : <p>{t('akoBooster')}</p>}
			</div>
			<div className="AkoBonusInfo__rightSide">
				<p>+{t('Common_currency', { val: bonusAmount })}</p>
			</div>
		</div>
	);
};

export default AkoBonusInfo;
